import React, { useCallback, useEffect } from 'react'
import { useParams } from 'react-router-dom'

import { useRecoilCallback, useRecoilValue } from 'recoil'

import ErrorFeedback from 'Components/ErrorFeedback'

import Header from './components/Header'
import Footer from './components/Footer'
import Intro from './components/Intro'
import ModalBeingSent from './components/ModalBeingSent'

import BlockingCount from './components/BlockingCount'
import BlockingDetails from './components/BlockingDetails'

import PotentialCount from './components/PotentialCount'

import ImprovementsCount from './components/ImprovementsCount'

import {
  Loading,
  Tooltip,
  SpacingVertical,
  SPACING_24,
  Grid,
  GridCell
} from 'mailup-web-components'

import { pageState } from 'Pages/MessageCheckupSummary/recoil/state/page'
import { initCallback } from 'Pages/MessageCheckupSummary/recoil/callbacks/callbacks'

import ImprovementsDetails from 'Pages/MessageCheckupSummary/components/ImprovementsDetails'
import PotentialDetails from './components/PotentialDetails'
import ModalNoEdit from './components/ModalNoEdit'
import InlineMessageBox from './components/InlineMessageBox'
import ModalManageAlerts from './components/ModalManageAlerts'
import PageContainer from 'Components/PageContainer'

const MessageCheckupSummary = () => {
  const { id } = useParams()
  const { loading, loaded, error, severity } = useRecoilValue(pageState)
  const init = useRecoilCallback(initCallback, [])

  const reloadPage = useCallback(() => {
    window.location.reload()
  }, [])

  useEffect(() => {
    init(id)
  }, [])

  return (
    <>
      <Header />
      <Loading open={loading} />
      <Tooltip />
      <ModalBeingSent />
      <ModalNoEdit />
      <ModalManageAlerts />
      <PageContainer>
        <InlineMessageBox />
        <ErrorFeedback
          error={error}
          severity={severity}
          onClickReload={reloadPage}
          data-mu-test='l-message-checkup-summary__error-feedback'
        />
        {!error && loaded && (
          <>
            <Intro />
            <SpacingVertical variant={SPACING_24} />

            <Grid cols={12}>
              <GridCell span={4}>
                <BlockingCount />
              </GridCell>
              <GridCell span={8}>
                <BlockingDetails />
              </GridCell>

              <GridCell span={4}>
                <PotentialCount />
              </GridCell>
              <GridCell span={8}>
                <PotentialDetails />
              </GridCell>

              <GridCell span={4}>
                <ImprovementsCount />
              </GridCell>
              <GridCell span={8}>
                <ImprovementsDetails />
              </GridCell>
            </Grid>

            <Footer />
          </>
        )}
      </PageContainer>
    </>
  )
}

export default MessageCheckupSummary
